import { createFileRoute } from '@tanstack/react-router';
import { QuickQuoteTerms } from '../../components/QuickQuoteTerms';

export const Route = createFileRoute('/quickquote/terms')({
  component: QuickQuoteTerms,
});
